import { projectsApi } from './projectsApi';

export interface UsageUser {
  id: number; name: string; email: string; user_type: string; affiliation: string;
  created_at: string; created_by_user_id: number | null; creation_source: string | null;
  accounts: { id: number; name: string }[]; accepted_terms_version: string | null;
  logins: number; login_days: number; active_days: number; engagement_seconds: number;
  new_registration: boolean; returning: boolean;
}
export interface UsageReport {
  source: string; timezone: string;
  period: { start_date: string; end_date: string; previous_start_date: string; previous_end_date: string };
  users: UsageUser[]; totals: Record<string, number>;
  daily_logins: { user_id: number; date: string; logins: number }[];
  daily_activity: { user_id: number; date: string; engagement_seconds: number }[];
  customer_usage: { client_id: number; client_name: string; user_id: number; tool: string; engagement_seconds: number }[];
  tool_usage: { current: Record<string, number>; previous: Record<string, number> };
  study_completions: { month: string; type: string; count: number }[];
  study_completion_totals: { current: Record<string, number>; previous: Record<string, number> };
  historical_completed_without_date: Record<string, number>;
  studies: { month: string; type: string; count: number }[];
  study_totals: { current: Record<string, number>; previous: Record<string, number> };
  study_details: { id: number; project: string; type: string; status: string; created_at: string; completed_at: string | null; created_by_user_id: number | null }[];
  coverage: { first_login_at: string | null; first_activity_at: string | null; first_acceptance_at: string | null; note: string };
}
export interface GoogleUsageReport {
  status: 'ok' | 'unavailable'; message?: string; timezone?: string; note?: string;
  user_type_dimension_available?: boolean;
  reports?: Record<string, { rows: Record<string, string | number>[]; metadata: { subjectToThresholding?: boolean; dataLossFromOtherRow?: boolean; samplingMetadatas?: unknown[] } }>;
}
export type UsageParams = { start_date: string; end_date: string; timezone: string; user_type?: string; user_id?: string; affiliation?: string; cohort?: string; user_types?: string; excluded_user_types?: string; user_ids?: string; excluded_user_ids?: string; affiliations?: string; account_ids?: string };
export const usageAnalyticsApi = projectsApi.injectEndpoints({
  endpoints: (builder) => ({
    getUsageAccess: builder.query<{ allowed: boolean }, void>({ query: () => 'service/usage-analytics/access' }),
    getUsageAnalytics: builder.query<UsageReport, UsageParams>({ query: (params) => ({ url: 'service/usage-analytics', params }), keepUnusedDataFor: 60 }),
    getGoogleUsageAnalytics: builder.query<GoogleUsageReport, UsageParams>({ query: (params) => ({ url: 'service/usage-analytics/google', params }), keepUnusedDataFor: 300 }),
    recordUsageActivity: builder.mutation<void, { event_id: string; session_id: string; expected_user_id: number; tool: string; project_id?: number; client_id?: number; portal_account_id?: number; engagement_seconds: number }>({
      query: (body) => ({ url: 'service/usage-analytics/activity', method: 'POST', body }),
    }),
  }),
});
export const { useGetUsageAccessQuery, useGetUsageAnalyticsQuery, useGetGoogleUsageAnalyticsQuery, useRecordUsageActivityMutation } = usageAnalyticsApi;
